import { render, staticRenderFns } from "./dashboard-recruiter.vue?vue&type=template&id=0b3d7025&scoped=true"
import script from "./dashboard-recruiter.vue?vue&type=script&lang=ts"
export * from "./dashboard-recruiter.vue?vue&type=script&lang=ts"
import style0 from "./dashboard-recruiter.vue?vue&type=style&index=0&id=0b3d7025&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3d7025",
  null
  
)

export default component.exports